

<template>
    <div class="Events">
        <ul class="list-group mb-0 visit-list events-wrapper">
            <li v-for="event in events" :key="event.nid" class="list-group-item rounded-0">
                <div class="date-wrapper">
                    <div class="date-box mr-3 text-center float-left">
                        <span class="month bg-primary text-white d-block">{{ event.field_single_day_event_date }} {{ event.field_multiple_days_event }}</span>
                        <h5 class="mb-0 p-1 date"> {{ event.field_single_day_event_date_1 }}</h5>
                    </div>
                    <div class="date-title">
                        <router-link :to="{ name: 'EventsDetail', params: { id: event.current_path }}" class="text-light">{{ event.title }}</router-link>
                    </div>
                </div>
            </li>
        </ul>
        <!-- End events-content -->
    </div>
</template>


<script>
    import axios from 'axios';
    export default {
        name: 'EventTeaser',
        data(){
            return {
                events: [],
            }
        },
        mounted() {
            axios
                .get('https://api.fifmi.org.au/api/events')
                .then(result => {
                    for (var i = 0; i < result.data.length; i++) {
                        if(result.data[i].field_domain_access.includes('fifmi')){
                            result.data[i].current_path = result.data[i].current_path.split('/').pop();
                            this.events.push(result.data[i])
                        }
                    }
                });
        }
    }
</script>

